module.exports = __webpack_public_path__ + "img/icon_ser.0f20b33.webp";